export const MAX_TOTAL_UPLOAD_SIZE = 50 * 1024 * 1024; // 50 MB

export const ALLOWED_EXTENSIONS = [".pdf", ".doc", ".docx", ".md"];

export const POLLING_STATUSES = new Set([
  "created",
  "awaiting_deploy_key",
  "analyzing",
  "generating_script",
  "regenerating_script",
]);

export const STATUS_GROUPS = [
  {
    label: "In Progress",
    options: ["analyzing", "generating_script", "regenerating_script", "executing"],
  },
  {
    label: "Awaiting Action",
    options: ["awaiting_deploy_key", "awaiting_review", "ready_to_execute"],
  },
  {
    label: "Completed",
    options: ["succeeded", "failed"],
  },
];



export const TARGETS = [
  {
    value: "gcp",
    title: "Google Cloud Platform",
    description:
      "Managed services via Terraform — Cloud Run, Cloud SQL, Secret Manager, Pub/Sub, Storage, Firestore.",
  },
  {
    value: "oci_vm",
    title: "Ubuntu VM (on OCI)",
    description:
      "Single Ubuntu 22.04 host configured via Ansible — runtime install, .env, systemd unit.",
  },
];

export const NEXT_STEPS = [
  { text: "We clone the repo at the chosen ref.",            highlight: false },
  { text: "The matching adapter analyzes code & docs.",      highlight: false },
  { text: "You review the proposal.",                        highlight: true  },
  { text: "A deployment script is generated.",               highlight: false },
  { text: "You execute and watch logs stream live.",         highlight: false },
];

